export default "__VITE_ASSET__BW_6cXwz__"